import moment from 'moment';

const SESSION_KEY = 'sessionAppId';

const defaults = {
  sessionId: sessionStorage ? sessionStorage.getItem(SESSION_KEY) : null,
  requestErrors: [],
  requestErrorUrl: '',
  language: 'ru',
  globalLocations: {
    from: null,
    to: null,
  },
  invoiceProcessingType: 0,
};

const api = {
  namespaced: true,
  state: { ...defaults },
  mutations: {
    setError(state, error) {
      state.requestErrors.push(error);
    },
    setErrorUrl(state, url) {
      state.requestErrorUrl = url;
    },
    /* eslint-disable no-unused-vars */
    removeError(state, error) {
      state.requestErrors = state.requestErrors.filter(e => e !== error);
      state.requestErrorUrl = '';
    },
    setSession(state, sessionId) {
      state.sessionId = sessionId;
    },
    setLangRu(state) {
      state.language = 'ru';
      moment.locale('ru');
    },
    setLangEn(state) {
      state.language = 'en';
      moment.locale('en');
    },
    setLocationTo(state, globalLocation) {
      state.globalLocations.to = globalLocation;
    },
    setLocationFrom(state, globalLocation) {
      state.globalLocations.from = globalLocation;
    },
    setInvoiceProcessingType(state, invoiceProcessingType) {
      state.invoiceProcessingType = invoiceProcessingType;
    },
  },
  actions: {
    setError({ commit }, error) {
      commit('setError', error);
    },
    setErrorUrl({ commit }, url) {
      commit('setErrorUrl', url);
    },
    removeError({ commit }, error) {
      commit('removeError', error);
    },
    setSessionId({ commit }, sessionId) {
      sessionStorage.setItem(SESSION_KEY, sessionId);
      commit('setSession', sessionId);
    },
    setLangRu({ commit }) {
      commit('setLangRu');
    },
    setLangEn({ commit }) {
      commit('setLangEn');
    },
    setLocationTo({ commit }, globalLocation) {
      commit('setLocationTo', globalLocation);
    },
    setLocationFrom({ commit }, globalLocation) {
      commit('setLocationFrom', globalLocation);
    },
  },
  getters: {
    language(state) {
      return state.language;
    },
    isProcessShipmentErrorUrl(state) {
      return state.requestErrorUrl === 'api/processShipment';
    },
  },
};

export default api;
